import { render, staticRenderFns } from "./FoodAllergies.vue?vue&type=template&id=4cba76f4"
import script from "./FoodAllergies.vue?vue&type=script&lang=js"
export * from "./FoodAllergies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports